export function install(Vue, options) {
	Vue.prototype.$debugLog = process.env.NODE_ENV == 'development'
		? function (...args) {
			console.log.apply(null, arguments);
		}
		: function () { };
}